<template>
  <div class="result">
    <el-carousel
      :interval="4000"
      type="card"
      indicator-position="none"
      height="600px"
    >
      <el-carousel-item v-for="(item, idx) in list" :key="idx">
        <h3 style="margin-bottom: 10px">{{ item.teamName }}</h3>
        <el-image
          :src="item.dyImg || require('@/assets/images/dy_cover.png')"
          fit="contain"
          style="width: 300px; height: 600px"
        >
        </el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { resultList } from "@/api/projectPractice/accountEstablish";

export default {
  data() {
    return {
      list: [],
    };
  },
  methods: {
    // 成果列表
    getList() {
      this.$loading.show();
      resultList({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>